module.exports = __webpack_public_path__ + "static/media/cruiserExplosions.7216f3ad.svg";